module.exports = __webpack_public_path__ + "img/5.49adb66e.png";